import type { ComponentPropertyBindingType } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';

/**
 * Returns whether or not the binding direction type is considered something
 * that can be WRITTEN from the OUTSIDE of the component (when not in template editor).
 * This also indicates that there can be a BINDING set up for the property on the instance
 * @param bindingType binding direction type
 * @returns whether or not the type is considered writeable from outside
 */
export default function isBindingTypeWriteableFromOutside(
  bindingType: ComponentPropertyBindingType | null | undefined,
): bindingType is 'inbound' | 'two-way' | null | undefined {
  switch (bindingType) {
    case 'outbound':
      // Outbound only, so readable from outside but not writable
      return false;
    case 'private':
    case 'private-data':
      // Private, so not accessible from outside
      return false;
    default:
      // Otherwise inbound, two-way, data-interface or null/undefined (legacy meaning two-way)
      // Is writeable from outside
      return true;
  }
}
